<template>
    <div class="container missingmapping">
        <div class="columns">
            <div class="column is-two-thirds">
                <p>Gjennom importfilene som leveres fra Evry kommer data inn i systemet som er avhengig av en eksisterende mapping for å rutes til riktig kunde. Dersom mapping ikke eksisterer på et element blir elementet liggende passivt uten å bli tatt i bruk av datagrunnlaget.</p>
                <p>OBS! Når mapping blir lagt inn vil det kunne ta en stund før data oppdaterer seg i applikasjonen. I den perioden vil produktet fremdeles ligge i denne listen og fremstå som et produkt som mangler mapping.</p>

                <p>Listen baserer seg kun på data som er importert inn i systemet allerede, og viser kun data som er hentet fra parkeringstabellen.</p>
            </div>

            <div class="column">
                <r0901 v-if="reportType === 'r0901'"></r0901>
                <cp v-if="reportType === 'cp'"></cp>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import R0901 from '@/components/missing/R0901'
import Cp from '@/components/missing/Cp'

export default {
    props: ['reportType'],
    components: {
        R0901, Cp
    },
    methods: {
        ...mapActions('missingmappings', ['getMissingFromService'])
    },
    mounted () {
        this.getMissingFromService(this.reportType)
    }
}
</script>

<style lang="scss" scoped>
    div.missingmapping {
        margin-top: 32px;
    }
    div.column {
        p {
            margin-bottom: 16px;
        }
    }
</style>
